import { NgModule } from '@angular/core';
import { Select2Module } from 'ng2-select2';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';

import { TreeTableModule } from './arvore-acesso/ng-tree-table/treetable';

import { SairService } from './sair.service';
import { TokenService } from './token.service';

import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { MenuModulosComponent } from './menu-modulos/menu-modulos.component';
import { MenuLateralComponent } from './menu-lateral/menu-lateral.component';
import { VisualizaCadastroComponent } from './visualiza-cadastro/visualiza-cadastro.component';
import { ManipulaCadastroComponent } from './manipula-cadastro/manipula-cadastro.component';
import { TabelaPaginacaoComponent } from './tabela-paginacao/tabela-paginacao.component';
import { ArvoreAcessoComponent } from './arvore-acesso/arvore-acesso.component';
import { ConfirmacaoComponent } from './confirmacao/confirmacao.component';
import { PicklistComponent } from './picklist/picklist.component';
import { AlertaNotificacaoComponent } from './alerta-notificacao/alerta-notificacao.component';
import { JanelaComponent } from './janela/janela.component';
import { AlertaComponent } from './alerta/alerta.component';
import { MensagemValidacaoComponent } from './mensagem-validacao/mensagem-validacao.component';
import { TextMaskModule } from 'angular2-text-mask';
import { FormSelectComponent } from './form-select/form-select.component';
import { NgSelect2Module } from 'ng-select2';
import { FormInputTextComponent } from './form-input-text/form-input-text.component';
import { FormInputTextareaComponent } from './form-input-textarea/form-input-textarea.component';
import { ModalComponent } from './modal/modal.component';
import { MenuSearchComponent } from './menu-search/menu-search.component';
import { FilterPipeMenuSearch } from './menu-search/FilterPipeMenuSearch';
import { MenuProfileComponent } from './menu-profile/menu-profile.component';

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    Ng2TableModule,
    CollapseModule,
    Select2Module,
    FormsModule,
    BrowserAnimationsModule,
    RouterModule,
    BrowserModule,
    TooltipModule.forRoot(),
    TreeTableModule,
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    ReactiveFormsModule,
    TextMaskModule,
    NgSelect2Module
  ],
  declarations: [
    CabecalhoComponent,
    MenuModulosComponent,
    MenuLateralComponent,
    JanelaComponent,
    VisualizaCadastroComponent,
    ManipulaCadastroComponent,
    TabelaPaginacaoComponent,
    ArvoreAcessoComponent,
    ConfirmacaoComponent,
    PicklistComponent,
    AlertaNotificacaoComponent,
    AlertaComponent,
    MensagemValidacaoComponent,
    FormInputTextComponent,
    FormSelectComponent,
    FormInputTextareaComponent,
    ModalComponent,
    MenuSearchComponent,
    FilterPipeMenuSearch,
    MenuProfileComponent
  ],
  exports: [
    CabecalhoComponent,
    MenuLateralComponent,
    JanelaComponent,
    VisualizaCadastroComponent,
    ManipulaCadastroComponent,
    TabelaPaginacaoComponent,
    ArvoreAcessoComponent,
    ConfirmacaoComponent,
    PicklistComponent,
    AlertaNotificacaoComponent,
    AlertaComponent,
    MensagemValidacaoComponent,
    FormInputTextComponent,
    FormSelectComponent,
    FormInputTextareaComponent,
    ModalComponent,
    MenuModulosComponent,
    MenuSearchComponent,
    MenuProfileComponent
  ],
  providers : [
    TokenService,
    SairService
  ]
})

export class AngularBaseUiModule { }



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/angular-base-ui.module.ts